import { useEffect, useState } from 'react';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers';
import { sxCalendar } from './sxProps';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import { LinhaTempoCalendarProps } from '../../../interfaces/props/SaudeOnline/LinhaTempo/LinhaTempoCalendarProps';
import { getDayName } from '../../../utils/DateFormat';

dayjs.locale('pt-br');

function Calendar(props: LinhaTempoCalendarProps) {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);

  useEffect(() => {
    if (props.selectedDate !== null) {
      setSelectedDate(dayjs(props.selectedDate))
    }
  }, [props.selectedDate])

  const handleDateChange = (date: Dayjs | null, selectionState?: 'finish' | 'partial' | 'shallow') => {
    if (date && selectionState === 'finish') {
      setSelectedDate(date);
      props.handleDate(date.toDate());
    }
  };

  function normalizeDate(date: string | null) {
    if (!date) return undefined;
    if (date.includes('T')) return dayjs(date);
    return dayjs(date, 'DD/MM/YYYY');
  }

  function disableDays(date: Dayjs) {
    const minDate = normalizeDate(props.minDate ?? null); 
    const maxDate = normalizeDate(props.maxDate ?? null);

    if (minDate && dayjs(date).isBefore(minDate)) {
      return true;
    }

    if (maxDate && dayjs(date).isAfter(maxDate)) {
      return true;
    }

    return dayjs().isBefore(date);
  }


  return (
    <div className="calendar">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          sx={sxCalendar}
          value={selectedDate}
          onChange={(date, selectionState) => handleDateChange(date, selectionState)}
          shouldDisableDate={disableDays}
          minDate={normalizeDate(props.minDate ?? null)}  // Normalizando minDate
          maxDate={dayjs()} 
          dayOfWeekFormatter={(day: string) => `${getDayName(day)}`}
        />
      </LocalizationProvider>
    </div>
  );
}

export default Calendar;